import styled from "styled-components";
import PButton from "../../../../components/PButton";

export const Container = styled.div`
  display: flex;
  margin-left: 100px;
  margin-right: 100px;
  border-radius: 5px;
  box-shadow: 0px 3px 6px #00000040;

  @media only screen and (max-width: 1080px) {
    margin-left: 0px;
    margin-right: 0px;
    flex-direction: column;
    width: 665px;
    margin: 0 auto;
  }

  @media only screen and (max-width: 768px) {
    margin-left: 0px;
    margin-right: 0px;
    flex-direction: column;
    width: 100%;
  }
`;

export const VideoCardContainer = styled.div`
  width: 565px;
  height: 317px;
  background-color: #e2e2e2;

  & {
    iframe {
      border-width: 0;
    }
  }

  @media only screen and (max-width: 1275px) {
    width: 500px;
  }
  
  @media only screen and (max-width: 1208px) {
    width: 100%;
    height: 350px;
  }

  @media only screen and (max-width: 1080px) {
    width: 100%;
    height: 350px;
  }

  @media only screen and (max-width: 768px) {
    width: 100%;
    height: 350px;
  }
  
  @media only screen and (max-width: 768px) {
    width: 100%;
    height: 270px;
  }
`;

export const SummaryContainer = styled.div`
  padding: 50px 30px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media only screen and (max-width: 1080px) {
    padding: 50px 50px;
  }
  
  @media only screen and (max-width: 560px) {
    padding: 40px 40px;
  }
`;

export const TitleText = styled.div`
  font-family: "Montserrat";
  font-weight: bold;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.blackGreen};
  text-transform: capitalize;

  @media only screen and (max-width: 1080px) {
    letter-spacing: 1.8px;
    font-size: 15px;
    padding-bottom: 10px;
    text-align: center;
  }
`;

export const SummaryText = styled.div`
  font-family: "Helvetica";
  font-size: 13px;
  letter-spacing: 0.78px;
  color: ${({ theme }) => theme.colors.black};

  @media only screen and (max-width: 1080px) {
    letter-spacing: 0.9px;
    font-size: 15px;
    padding-bottom: 30px;
    text-align: center;
  }

  @media only screen and (max-width: 560px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

export const ActionButton = styled(PButton)`
  padding-left: ${({ theme }) => theme.spacings.spacing_xxl_m};
  padding-right: ${({ theme }) => theme.spacings.spacing_xxl_m};
  border-radius: 0;
  border: solid 2px ${({ theme }) => theme.colors.prune};
  height: 42px;
  width: 212px;
  & span {
    font-size: 14px;
    font-family: "Helvetica";
    font-weight: bold;
    color: ${({ theme }) => theme.colors.prune};
  }

  @media only screen and (max-width: 1080px) {
    width: 374px;
    align-self: center;
  }

  @media only screen and (max-width: 560px) {
    width: 80%;
    & span {
      font-size: 16px;
    }
  }
`;
